import { Controller } from "@hotwired/stimulus";

// Asks before saving keywords that have no search volume, unless the missing
// volumes are about to be fetched from DataForSEO or come from an imported CSV.
export default class extends Controller {
  static targets = ["fetchToggle"];

  confirm(event) {
    // Buttons that do not save keywords (the wizard's "Use manual entry instead").
    if (event.submitter?.dataset.skipVolumeCheck !== undefined) return;
    if (this.hasFetchToggleTarget && this.fetchToggleTarget.checked) return;

    const csvInput = this.element.querySelector('input[type="file"][name="wizard[csv_file]"]');
    if (csvInput && csvInput.files.length > 0) return;

    const missing = [...this.element.querySelectorAll("[data-keyword-row]")].filter((row) => {
      const keyword = row.querySelector('[data-wizard-topics-target="keywordInput"]');
      const volume = row.querySelector("[data-search-volume-input]");
      return keyword && volume && keyword.value.trim() !== "" && volume.value.trim() === "";
    }).length;
    if (missing === 0) return;

    const subject = missing === 1 ? "1 keyword has" : `${missing} keywords have`;
    const message = `${subject} no search volume and will be left out of the AI share of voice. Save anyway?`;
    if (!window.confirm(message)) event.preventDefault();
  }
}
